const MessageReducer = (state = {}, action) => {
    switch (action.type) {
        case 'SET_MESSAGE':
            return {
                ...state,
                ...action.payload,
            };
        case 'CLEAR_MESSAGE':
            const newState = { ...state };
            delete newState[action.payload];
            return newState;
        default:
            return state;
    }
}

export default MessageReducer;